import * as React from 'react';
import { SVGProps } from 'react';

const SvgCompanies = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <g clipPath="url(#companies_svg__a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.65 0a.75.75 0 0 0-.75.75v6.766a.75.75 0 0 0 1.5 0V1.5h7.2v4.083a.75.75 0 0 0 1.5 0V.75a.75.75 0 0 0-.75-.75h-8.7ZM.75 8.7a.75.75 0 0 0-.75.75v5.799c0 .414.336.75.75.75H15.25a.75.75 0 0 0 .75-.75V7.516a.75.75 0 0 0-.75-.75h-5.8a.75.75 0 0 0-.75.75V14.5H7.3v-5.05a.75.75 0 0 0-.75-.75H.75Zm.75 5.799v-4.3h4.3v4.3H1.5Zm8.7-6.233V14.5h4.299V8.266h-4.3ZM2.682 11.6a.75.75 0 0 0 0 1.5h1.933a.75.75 0 0 0 0-1.5H2.683Zm7.95-1.183a.75.75 0 0 1 .75-.75h1.933a.75.75 0 1 1 0 1.5h-1.933a.75.75 0 0 1-.75-.75Zm.75 1.183a.75.75 0 0 0 0 1.5h1.933a.75.75 0 1 0 0-1.5h-1.933Zm-4.833-8.7a.75.75 0 1 0 0 1.5h2.9a.75.75 0 1 0 0-1.5h-2.9Z"
        fill="#174174"
      />
    </g>
    <defs>
      <clipPath id="companies_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgCompanies;
